import Vue from 'vue';

class InitService {

  constructor() {
    this.lastAuthorizeData = null;
  }

  authorizeDeviceByCode(code) {
    if (code) {
      Vue.prototype.$socketService.send({
        type: 'start',
        payload: {
          code: code
        }
      });
    }
  }
  authorizeDeviceByUID(UID) {
    if (UID) {
      Vue.prototype.$socketService.send({
        type: 'start',
        payload: {
          uid: UID
        }
      })
    }
  }
  authorizeOperatorDevice(access_token, UID) {
    if (access_token && UID) {
      Vue.prototype.$socketService.send({
        type: 'start',
        payload: {
          token: access_token,
          uid: UID
        }
      })
    }
  }
}

export default InitService;
